export const SaveVerse = {
    methods: {
       saveVerseDetails() {
            const dataObj = this.$store.getters.getCurrentVerse;
            const verse = dataObj.bookName + dataObj.chapterAndVerse;
            const collection = this.$store.getters.getUserId
            db.collection(collection).doc(verse).set(dataObj);
        },
    },
}


// WEBPACK FOOTER //
// ./src/mixins/SaveVerseMixin.js